// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"kp-z","selected":"lp-z"};